module.exports = __webpack_public_path__ + "static/img/food.60b46dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/course/food.png
// module id = QSKL
// module chunks = 6